module.exports = __webpack_public_path__ + "static/media/9_bass_a.8f0d94db.ogg";